import { Dialog, DialogContent } from 'components/UI/Modal/ModalPrimitive'
import { useState } from 'react'
import { AddTagsStep } from './AddTagsStep'
import { ColumnsStep } from './ColumnsStep'
import { ImportContactProvider } from './ImportContactContext'
import { MatchCompanyStep } from './MatchCompanyStep'
import { OpportunityTypeStep } from './OpportunityTypeStep'
import { PreviewFailedStep } from './PreviewFailedStep'
import { PreviewSuccessfulStep } from './PreviewSuccessfulStep'
import UploadStep from './UploadStep'

export default function ImportContactModal({
  show,
  handleClose,
  onContactsImported,
}: {
  show: boolean
  handleClose: () => void
  onContactsImported?: () => void
}) {
  const [step, setStep] = useState(0)

  return (
    <Dialog open={show} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent id={'fb-modal-content'} size="2xl">
        <ImportContactProvider
          handleClose={handleClose}
          onStepChange={setStep}
          onContactsImported={onContactsImported}
        >
          <div className={step === 0 ? '' : 'd-none'}>
            <UploadStep />
          </div>
          {step === 1 && <OpportunityTypeStep />}
          {step === 2 && <ColumnsStep />}
          {step === 3 && <MatchCompanyStep />}
          {step === 4 && <PreviewSuccessfulStep />}
          {step === 5 && <PreviewFailedStep />}
          {step === 6 && <AddTagsStep />}
        </ImportContactProvider>
      </DialogContent>
    </Dialog>
  )
}
